/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */




import BaseObject from "@shared/BaseObject";
import {isAppTheraLogik} from "@/utils/helpers";
import {CurrencyCodeEnum} from "@shared/Profile/CurrencyCodeEnum";

export default class CurrencyItem extends BaseObject{

	currencyName: string = ""
	currencyCode: string = ""
	currencySign: string = ""


	constructor(currencyCode: string = "", currencySign: string = "", currencyName: string = "") {
		super();
		this.currencyCode = currencyCode;
		this.currencySign = currencySign;
		this.currencyName = currencyName
	}

	toString(){
		return this.currencySign || this.currencyName
	}
	formatted(amount = 0, options = {}){
		if(typeof options === Number){
			options = {fractionalDigits: options}
		}

		let {fractionalDigits = 2, skipCurrencyCode} = options

		amount = parseFloat(Number(amount)).toFixed(fractionalDigits);
		// amount = Number(amount)
		// amount = Math.ceil(amount * 100) / 100
		// amount = amount.toFixed(fractionalDigits)
		let currencyCode = skipCurrencyCode ? "" : this.currencyCode
		if(this.currencySign){
			return this.currencySign + amount + "" + currencyCode
		}
		return "" + amount + " " + this.currencyName
	}

	static currencyByCode(code){
		// console.log("CurrencyItem.currencyList = ", CurrencyItem.currencyList, " code = ", code)
		for(let currency of CurrencyItem.currencyList){
			if(currency.currencyCode === code){
				return currency
			}
		}
		return CurrencyItem.USD
	}

	static USD = new CurrencyItem(CurrencyCodeEnum.USD, "$", "US Dollar")
	static EUR = new CurrencyItem(CurrencyCodeEnum.EUR, "€", "Euro")
	static GBP = new CurrencyItem(CurrencyCodeEnum.GBP, "£", "British Pound Sterling")
	static NZD = new CurrencyItem(CurrencyCodeEnum.NZD, "$", "New Zealand Dollar")
	static AUD = new CurrencyItem(CurrencyCodeEnum.AUD, "$", "Australian Dollar")
	static CAD = new CurrencyItem(CurrencyCodeEnum.CAD, "$", "Canadian Dollar")
	static JPY = new CurrencyItem(CurrencyCodeEnum.JPY, "¥", "Japanese Yen")
	static CNY = new CurrencyItem(CurrencyCodeEnum.CNY, "¥", "Chinese Yuan")
	static RUB = new CurrencyItem(CurrencyCodeEnum.RUB, "₽", "Russian Ruble")
	static INR = new CurrencyItem(CurrencyCodeEnum.INR, "₹", "Indian Rupee")
	static BRL = new CurrencyItem(CurrencyCodeEnum.BRL, "R$", "Brazilian Real")
	static PHP = new CurrencyItem(CurrencyCodeEnum.PHP, "₱", "Philippine Peso")


	static currencyList = [
		CurrencyItem.USD,
		CurrencyItem.EUR,
		CurrencyItem.GBP,
		CurrencyItem.AUD,
		CurrencyItem.CAD,
		CurrencyItem.JPY,
		CurrencyItem.CNY,
		CurrencyItem.RUB,
		CurrencyItem.INR,
		CurrencyItem.BRL,
		CurrencyItem.PHP,
	]

}

export const getCurrencyItemByCode = (currencyCode) => {

	let currencyItem = CurrencyItem.currencyList.find(currencyItem => currencyItem.currencyCode === currencyCode)

	return currencyItem || CurrencyItem.GBP
}

export const CURRENCY_FORMATTING_OPTIONS_SHORT = { fractionalDigits: 2, skipCurrencyCode: true }

export const currencyFormatted = (currencyCode, amount, options) =>{
	let currencyItem = getCurrencyItemByCode(currencyCode)
	return currencyItem.formatted(amount, options)
}

export const defaultCurrency = isAppTheraLogik ? CurrencyItem.GBP : CurrencyItem.USD
export const defaultCurrencyCode = isAppTheraLogik ? CurrencyCodeEnum.GBP : CurrencyCodeEnum.USD
